@if (mobileOpen()) {
  <div
    aria-hidden="true"
    class="fixed inset-0 z-40 bg-black/50 lg:hidden"
    data-testid="menu-backdrop"
    (click)="closeMobileMenu()"
  ></div>
}

<div
  class="relative h-full w-screen transition-[width,transform] duration-200 ease-[cubic-bezier(0.4,0,0.2,1)] fixed inset-y-0 left-0 z-50 lg:relative lg:inset-auto"
  data-testid="menu-sidebar"
  [ngClass]="[
    mobileOpen() ? 'translate-x-0' : '-translate-x-full lg:translate-x-0',
    sidebarCollapsed() ? 'lg:w-20' : 'lg:w-56'
  ]"
  (transitionend)="onSidebarTransitionEnd($event)"
  >
  <button
    type="button"
    data-testid="sidebar-collapse-toggle"
    class="absolute top-14 z-[60] hidden h-7 w-7 -translate-y-1/2 items-center justify-center rounded-full border border-primary-100 bg-basic-100 text-primary-500 shadow-md shadow-primary-500/20 transition-[opacity,transform,colors,box-shadow] duration-200 ease-out hover:scale-105 hover:border-primary-500 hover:bg-primary-500 hover:text-basic-100 hover:shadow-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-200 lg:flex -right-3"
    [ngClass]="sidebarContentVisible() ? 'opacity-100' : 'pointer-events-none opacity-0'"
    (click)="toggleSidebarCollapsed()"
    [attr.aria-label]="sidebarCollapsed() ? 'Expandir menu' : 'Recolher menu'"
    [attr.aria-hidden]="sidebarContentVisible() ? null : true"
  >
    <l-icon
      class="text-[16px] transition-transform duration-200"
      [icon]="sidebarCollapsed() ? 'chevron_right' : 'chevron_left'"
      aria-hidden="true"
    />
  </button>

  <div class="flex h-full flex-col overflow-hidden border-r border-white/10 bg-primary-500">
  <header
    class="flex h-12 shrink-0 items-center border-b border-white/10 px-2 w-full box-border justify-between"
    [ngClass]="showCollapsedSidebar() ? 'lg:justify-center' : ''"
  >
    <img
      class="h-auto object-contain brightness-0 invert opacity-90 transition-[max-width,width] duration-200 ease-[cubic-bezier(0.4,0,0.2,1)]"
      [ngClass]="showCollapsedSidebar() ? 'max-w-[2.25rem]' : 'max-w-[5.5rem] w-full'"
      alt="liga"
      width="112"
      height="20"
      data-testid="menu-logo"
      [ngSrc]="'/assets/images/logo.webp'"
      >

    <button
      lButton
      bContent="icon"
      bSize="small"
      bType="light"
      outline
      type="button"
      class="block lg:hidden !border-white/40 hover:!bg-white/10"
      (click)="closeMobileMenu()"
      aria-label="Fechar menu"
      >
      <l-icon class="text-inherit" icon="close" aria-hidden="true" />
    </button>
  </header>

    <div
      class="flex min-h-0 flex-1 flex-col transition-opacity duration-100 ease-out"
      data-testid="menu-sidebar-content"
      [ngClass]="sidebarContentVisible() || mobileOpen() ? 'opacity-100' : 'pointer-events-none opacity-0'"
      [attr.aria-hidden]="sidebarContentVisible() ? null : true"
    >
    <nav
      role="navigation"
      class="relative flex-1 min-h-0 m-0 mb-0 flex flex-col px-2 py-1"
      aria-label="Menu principal"
      >
      <div
        class="pointer-events-none absolute inset-x-2 bottom-1 z-[1] h-7 bg-gradient-to-t from-primary-500 from-15% to-transparent to-100%"
        aria-hidden="true"
      ></div>
      <ul class="menu-nav-scroll relative z-0 m-0 min-h-0 flex-1 list-none space-y-0.5 pb-5 overflow-y-auto scroll-smooth p-0 py-0.5 pr-1">
        @for (group of menuGroups; track $index) {
          @if (group.label && !showCollapsedSidebar()) {
            <li class="list-none px-1 pt-7 pb-1.5 first:pt-1" data-testid="menu-group-label">
              <l-text
                t="small3"
                tone="mist90"
                strong="semibold"
                flow="block"
                class="text-[9px] uppercase tracking-wide opacity-75"
              >
                {{ group.label }}
              </l-text>
            </li>
          }
          @for (menu of group.items; track menu.key ?? menu.title) {
            <li>
              <ng-container *ngTemplateOutlet="menuItem; context: { menu, index: menuIndex(menu) }" />
            </li>
          }
        }
      </ul>
    </nav>

    <footer class="shrink-0 px-2 pb-2 pt-0">
      @if (showCollapsedSidebar()) {
        <button
          type="button"
          class="relative mb-2 w-full overflow-hidden rounded-xl bg-basic-100 p-2.5 text-left ring-2 ring-white/70 shadow-xl transition-transform duration-200 hover:scale-[1.02] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-200"
          data-testid="menu-docs-collapsed"
          (click)="openDocs()"
          aria-label="Abrir documentação"
        >
          <ng-container *ngTemplateOutlet="docsCardBackground" />
          <span class="relative z-[1] flex items-center justify-center">
            <span class="flex h-8 w-8 items-center justify-center rounded-full bg-primary-100 ring-1 ring-primary-200">
              <l-icon class="text-[18px] text-primary-500" icon="menu_book" aria-hidden="true" />
            </span>
          </span>
        </button>
      } @else {
      <button
        type="button"
        data-testid="menu-docs-expanded"
        class="group mb-2 flex w-full items-center gap-2.5 rounded-lg border border-white/25 bg-primary-100 px-3 py-2.5 text-left shadow-sm transition-all duration-200 hover:border-white/40 hover:bg-basic-100 hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/60"
        (click)="openDocs()"
        aria-label="Abrir documentação"
      >
        <span class="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-primary-500 text-white shadow-sm">
          <l-icon class="text-[16px]" icon="menu_book" aria-hidden="true" />
        </span>

        <span class="min-w-0 flex-1">
          <l-text t="body2" tone="primary" strong="semibold" flow="block" class="leading-tight">
            Precisa de ajuda?
          </l-text>
          <l-text t="small3" tone="muted" flow="block" class="mt-0.5 leading-snug">
            Consulte a documentação
          </l-text>
        </span>

        <l-icon
          class="shrink-0 text-[18px] text-primary-400 transition-[transform,color] duration-200 group-hover:translate-x-0.5 group-hover:text-primary-500"
          icon="chevron_right"
          aria-hidden="true"
        />
      </button>
      }

        <!-- <div class="flex justify-between items-center cursor-pointer">
            <l-icon class="w-10 text-text-400" src="assets/images/liga-footer.svg" />
            <span class="text-text-400 text-xs">v1.0.0</span>
          </div>-->
    </footer>
    </div>
  </div>
  </div>

  <ng-template #menuItem let-menu="menu" let-index="index">
    @if (menu.wip) {
      <span
        class="flex w-full min-w-0 cursor-default rounded-lg border-r-4 border-transparent text-white/60"
        [ngClass]="showCollapsedSidebar() ? 'flex-col items-center gap-1 px-1 py-2.5' : 'items-start gap-2.5 px-3 py-2'"
        [attr.aria-label]="menu.title + ' (em desenvolvimento)'"
        aria-disabled="true"
      >
        <span class="flex h-5 w-5 shrink-0 items-center justify-center">
          <l-icon class="text-[18px] leading-none text-primary-200/80" aria-hidden="true" [icon]="menu.icon" />
        </span>
        @if (showCollapsedSidebar()) {
          <span
            data-testid="menu-item-title-collapsed"
            class="block w-full min-w-0 overflow-hidden text-ellipsis whitespace-nowrap text-center text-[9px] font-medium leading-[1.15] text-white/60"
            [attr.title]="menu.title"
          >
            {{ menu.title }}
          </span>
        } @else {
          <l-text t="body2" tone="mist90" strong="medium" class="min-w-0 flex-1 break-words leading-snug" flow="block" data-testid="menu-item-title">
            {{ menu.title }}
          </l-text>
          <span
            class="shrink-0 rounded px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide bg-white/15 text-white/80"
          >
            WIP
          </span>
        }
      </span>
    } @else {
      <a
        class="flex w-full min-w-0 cursor-pointer rounded-lg border-r-4 border-transparent no-underline transition-all duration-200 ease-out motion-reduce:transition-none"
        [ngClass]="[
          showCollapsedSidebar() ? 'flex-col items-center gap-1 px-1 py-2.5' : 'items-start gap-2.5 px-3 py-2',
          isMenuActive(menu)
            ? 'bg-primary-100 text-primary-500 border-primary-500'
            : 'text-white/95 hover:bg-white/10 border-transparent'
        ]"
        (click)="toggleMenu(index); closeMobileMenu()"
        [routerLink]="menu.link"
        [attr.aria-current]="isMenuActive(menu) ? 'page' : null"
        [attr.aria-label]="menu.title"
      >
        <span class="flex h-5 w-5 shrink-0 items-center justify-center transition-colors duration-200 ease-out motion-reduce:transition-none">
          <l-icon
            [ngClass]="isMenuActive(menu) ? 'text-primary-500' : 'text-primary-200'"
            class="text-[18px] leading-none transition-colors duration-200 ease-out motion-reduce:transition-none"
            aria-hidden="true"
            [icon]="menu.icon"
          />
        </span>
        @if (showCollapsedSidebar()) {
          <span
            data-testid="menu-item-title-collapsed"
            class="block w-full min-w-0 overflow-hidden text-ellipsis whitespace-nowrap text-center text-[9px] font-medium leading-[1.15] transition-colors duration-200 ease-out motion-reduce:transition-none"
            [ngClass]="isMenuActive(menu) ? 'text-primary-500' : 'text-white/80'"
            [attr.title]="menu.title"
          >
            {{ menu.title }}
          </span>
        } @else {
          <l-text
            t="body2"
            [tone]="isMenuActive(menu) ? 'primary' : 'mist90'"
            [strong]="isMenuActive(menu) ? 'semibold' : 'medium'"
            class="min-w-0 flex-1 break-words leading-snug transition-colors duration-200 ease-out motion-reduce:transition-none"
            flow="block"
            data-testid="menu-item-title"
          >
            {{ menu.title }}
          </l-text>
        }
      </a>
    }
  </ng-template>

  <ng-template #docsCardBackground>
    <div class="absolute inset-0 pointer-events-none overflow-hidden">
      <svg
        class="absolute -right-6 -top-6 h-[130%] w-[130%] text-primary-500/30"
        viewBox="0 0 240 240"
        fill="none"
        aria-hidden="true"
        >
        <path
          d="M-20 200 C60 140 120 180 260 40"
          stroke="currentColor"
          stroke-width="1.2"
          stroke-opacity="0.55"
          fill="none"
          />
        <path
          d="M40 260 C100 120 180 100 280 -20"
          stroke="currentColor"
          stroke-width="1"
          stroke-opacity="0.35"
          fill="none"
          />
        <path
          d="M-30 120 C40 80 140 60 270 20"
          stroke="currentColor"
          stroke-width="0.9"
          stroke-opacity="0.4"
          fill="none"
          />
        <path
          d="M20 240 C80 160 160 140 300 60"
          stroke="currentColor"
          stroke-width="0.85"
          stroke-opacity="0.32"
          fill="none"
          />
        <path
          d="M220 -10 C160 50 100 130 0 200"
          stroke="currentColor"
          stroke-width="1"
          stroke-opacity="0.28"
          fill="none"
          />
        <path
          d="M180 250 C220 180 240 100 260 0"
          stroke="currentColor"
          stroke-width="0.75"
          stroke-opacity="0.38"
          fill="none"
          />
      </svg>
    </div>
  </ng-template>
